export default import.meta.ROLLUP_FILE_URL_36uNF$w5M6NODXpE_S5ZzQ